const ITEMS = [
  "Organic Cow Milk",
  "Home Delivery · Vyara",
  "Village First",
  "Traditional Curd",
  "Weekend Farm Visits",
  "Pure Cow Ghee",
  "@adveshta.cow",
  "Fresh Buttermilk",
  "Gobar Gas Powered",
  "Ayurveda Approved",
];

const Row = ({ hidden = false }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={item} className="flex items-center">
        <span
          className={`whitespace-nowrap text-2xl md:text-4xl px-6 md:px-10 ${
            i % 2 === 0 ? "font-serif italic text-pine" : "font-mono uppercase tracking-[0.2em] text-royal text-lg md:text-2xl"
          }`}
        >
          {item}
        </span>
        <span className="h-2.5 w-2.5 rotate-45 bg-gold shrink-0" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section
      data-testid="marquee-band"
      className="border-y border-pine/20 bg-parchment py-6 md:py-8 overflow-hidden"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row hidden />
      </div>
    </section>
  );
}
